import store from '../store'
import { HttpClient } from './httpClient'
import {
  merchandiseDuty,
  merchandiseLineItem,
  invoiceItemData,
  container,
  manufacturer
} from '../formSections/util/initialValues'
import {
  addDutyItem,
  addMerchandiseLineItem,
  createInvoiceLineItem,
  updateArticleSubComponent
} from '../actions/DescriptionOfMerchandiseActions'
import { addContainer } from '../actions/BOLInfoActions'
import { addManufacturer } from '../actions/ImporterActions'
import { showToast } from '../util/showToast';
import { updateAndSaveTotals, updateTheseFieldsTotals, invalidateTotals } from '../actions/DescriptionOfMerchandiseActions';
import get from "lodash/get";
const createEvent = eventMessage => ({
  eventType: 'SAVE_ENTRY_SUMMARY_FORM',
  eventTime: Date.now(),
  eventMessage
})


export const createMerchandiseLineItem = (invoiceId ,invoiceItemIndex ,updateStatus , lineType, merchandiseId, pscShipId, insertIndex = undefined, copyAfterMerchId = undefined, isBlankCopy = undefined) => {
  
  // For UPSERT_LINE_ITEM API: copyAfterMerchId is always required
  // isBlankCopy: 1 = empty line item, 2 = copy data
  // For backward compatibility with ArticleHeader and ArticleSetSubComponent, use old logic
  
  // Check if there are no line items available - if so, use SAVE_ENTRY_SUMMARY_FORM logic
  const state = store.getState();
  const merchandiseLineItems = get(state, `DescriptionOfMerchandise.entrySummaryInvoices[${invoiceItemIndex}].merchandiseLineItems`, []);
  const hasNoLineItems = !merchandiseLineItems || merchandiseLineItems.length === 0;
  
  // Use UPSERT_LINE_ITEM for NormalLineItem or empty string (only if line items exist)
  if ((lineType === 'NormalLineItem' || lineType === '') && !hasNoLineItems) {
    // Use UPSERT_LINE_ITEM format
    // copyAfterMerchId is always required - it's where to insert the new item AFTER
    // isBlankCopy: 1 = empty line item, 2 = copy data
    if (copyAfterMerchId === undefined || copyAfterMerchId === null) {
      console.error('copyAfterMerchId is required for NormalLineItem');
      throw new Error('copyAfterMerchId is required');
    }
    
    const addMerchandiseObj = {
      copyAfterMerchId: copyAfterMerchId,
      isBlankCopy: isBlankCopy !== undefined ? isBlankCopy : 1 // Default to empty if not specified
    };
    
    const eventMsg = {
      descriptionOfMerchandise: {
        entrySummaryInvoices: [{
          shipmentId: pscShipId || window.shipmentId,
          invoiceId,
          merchandiseLineItems: [
            {
              addMerchandise: addMerchandiseObj
            }
          ]
        }]
      },
      shipmentId: pscShipId || window.shipmentId
    };
    
    // Use UPSERT_LINE_ITEM event type
    const dataSent = {
      eventType: 'UPSERT_LINE_ITEM',
      eventTime: Date.now(),
      eventMessage: eventMsg
    };
    
    return HttpClient.post(dataSent)
      .then(response => {
        if (response.data.eventMessage.code && response.data.eventMessage.code != 200) {
          console.log('ERROR:: UPSERT_LINE_ITEM', response.data.eventMessage);
          throw new Error(response.data.eventMessage.message || 'Failed to create line item');
        }
        
        // Check for warnings in the response
        const eventMessage = response.data.eventMessage;
        if (eventMessage?.warnings) {
          // Handle warnings - could be an object with msg property or an array
          let warningMsg = '';
          if (typeof eventMessage.warnings === 'object' && !Array.isArray(eventMessage.warnings)) {
            // Warnings is an object with msg property
            warningMsg = get(eventMessage, 'warnings.msg', 'Warning: Line item created with warnings');
          } else if (Array.isArray(eventMessage.warnings) && eventMessage.warnings.length > 0) {
            // Warnings is an array - extract messages
            warningMsg = eventMessage.warnings.map(w => w.msg || w.message || JSON.stringify(w)).join('; ');
          } else {
            warningMsg = 'Warning: Line item created with warnings';
          }
          showToast(warningMsg);
        }
        
        // Response contains all invoices with updated merchandise items and new sequence numbers
        // seqNo is updated for all line items across all invoices
        const responseInvoices = get(response, 'data.eventMessage.descriptionOfMerchandise.entrySummaryInvoices', []);
        
        if (responseInvoices && responseInvoices.length > 0) {
          // Process all invoices in the response
          responseInvoices.forEach((responseInvoice, index) => {
            if (responseInvoice && responseInvoice.merchandiseLineItems) {
              // Find the invoice index in the store by matching invoiceId
              const state = store.getState();
              const storeInvoices = get(state, 'DescriptionOfMerchandise.entrySummaryInvoices', []);
              const storeInvoiceIndex = storeInvoices.findIndex(inv => inv.invoiceId === responseInvoice.invoiceId);
              
              if (storeInvoiceIndex !== -1) {
                // Pass raw response items to reducer - it will merge only fields that are present
                // This allows partial updates (e.g., only seqNo) without losing other data
                store.dispatch({
                  type: 'UPDATE_INVOICE_MERCHANDISE_LINE_ITEMS',
                  invoiceItemIndex: storeInvoiceIndex,
                  merchandiseLineItems: responseInvoice.merchandiseLineItems, // Pass raw response items
                  totalEnteredValue: responseInvoice.totalEnteredValue,
                  totalCharges: responseInvoice.totalCharges
                });
              }
            }
          });
        }
        
        // Update shipment-level totalCharges if present in response
        const descriptionOfMerchandise = get(eventMessage, 'descriptionOfMerchandise', {});
        if (descriptionOfMerchandise && (descriptionOfMerchandise.charges !== undefined || descriptionOfMerchandise.totalCharges !== undefined)) {
          store.dispatch(updateTheseFieldsTotals(
            eventMessage,
            {
              shipment_AAA: ["charges", "totalCharges"],
              invoice_AAA: ["charges", "totalCharges"],
              merchandise_AAA: ["charges", "totalCharges"],
            }
          ));
        }
        
        // Update totals if present in response (HMF, MPF, duty, fee, tax, etc.)
        if (get(eventMessage, 'hmf.fee', null)) {
          store.dispatch(updateAndSaveTotals(
            eventMessage.hmf.fee,
            eventMessage.mpf?.fee || 0,
            eventMessage.duty || 0,
            eventMessage.fee || 0,
            eventMessage.tax || 0,
            eventMessage.additionalDuties || {},
            eventMessage.bondedAdDutyAmt || 0,
            eventMessage.bondedCvdDutyAmt || 0,
            eventMessage.cashAdDutyAmt || 0,
            eventMessage.cashCvdDutyAmt || 0,
            eventMessage.grandTotal || 0,
            eventMessage
          ));
        }

        // Copy line (isBlankCopy === 2) brings duties/fees — mark grand total stale for recalculate
        if (addMerchandiseObj.isBlankCopy === 2) {
          store.dispatch(invalidateTotals());
        }
        
        updateStatus(merchandiseId);
        return response;
      })
      .catch(error => {
        console.error('Error in createMerchandiseLineItem (UPSERT_LINE_ITEM):', error);
        updateStatus(merchandiseId);
        throw error;
      });
  }
  
  // Old logic for ArticleHeader and ArticleSetSubComponent
  let addMerchandiseObj = {
    copyAfterMerchId: copyAfterMerchId || null,
    isBlankCopy: lineType === 'NormalLineItem' ? 1 : 2
  };
  
  let newLine = {
    "addMerchandise": addMerchandiseObj
  };
  
  let eventMsg = {
    descriptionOfMerchandise: {
      entrySummaryInvoices :[{
        shipmentId: pscShipId || window.shipmentId,
        invoiceId,
        merchandiseLineItems: [
          newLine
        ]
      }]
    
    },
    shipmentId: pscShipId || window.shipmentId
  };
  if(lineType === 'NormalLineItem'){
    eventMsg.descriptionOfMerchandise.entrySummaryInvoices[0].merchandiseLineItems[0].merchandiseId = 'CREATE'
  }
  if(lineType === 'ArticleHeader'){
    eventMsg.descriptionOfMerchandise.entrySummaryInvoices[0].merchandiseLineItems[0].articleSetId = 'CREATE'
  }
  if(lineType === 'ArticleSetSubComponent'){
    eventMsg.descriptionOfMerchandise.entrySummaryInvoices[0].merchandiseLineItems[0].merchandiseId = 'CREATE'
    eventMsg.descriptionOfMerchandise.entrySummaryInvoices[0].merchandiseLineItems[0].articleSetId = merchandiseId;
  }
  let dataSent = createEvent(eventMsg)
  return HttpClient.post(dataSent)
    .then(response => {
      if(response.data.eventMessage.code && response.data.eventMessage.code!=200){
        console.log('ERROR::  CREATE MerchandiseDutyItem', response.data.eventMessage);
        return;
      }
      if(lineType === 'ArticleHeader' && response.data.eventMessage.merchandise){
        let merchandiseList = response.data.eventMessage.merchandise;
          merchandiseList.forEach((item)=>{
            let newLineItem = merchandiseLineItem()
            newLineItem.merchandiseId = item.merchandiseId
            newLineItem.grossWeight= { "weight": get(item, "grossWeight.weight") || "" }
            newLineItem.grossWeight.weightUnits=   get(item, "grossWeight.weightUnits")  || "None"
            newLineItem.productClaimCode=  item.productClaimCode || ""
            newLineItem.partRefreshFlag=  item.partRefreshFlag || ""
            newLineItem.categoryCode=  item.categoryCode || ""
            newLineItem.pgaFlags = item.pgaFlags || {}
            newLineItem.articleHeader = item.articleHeader || ''
            newLineItem.articleSetId = item.articleSetId || ''
            newLineItem.importerAdditionalDeclarationDetails = item.importerAdditionalDeclarationDetails || null
            newLineItem.seqNo = item.seqNo || ''
            if(item.articleHeader === 'X'){
              newLineItem.articleSubComponent = item.articleSubComponent || []
            }            
            newLineItem.merchandiseDuties[0].merchandiseDutyId =   item.merchandiseDuties[0].merchandiseDutyId
            //new added
            newLineItem.merchandiseDuties[0].manifestQuantity =  item.merchandiseDuties[0].manifestQuantity || {}
            newLineItem.merchandiseDuties[0].additionalQuantity =  item.merchandiseDuties[0].additionalQuantity || {}
            newLineItem.merchandiseDuties[0].unitPrice =  item.merchandiseDuties[0].unitPrice || ""
            newLineItem.merchandiseDuties[0].enteredValue =  item.merchandiseDuties[0].enteredValue || "0.00"
            newLineItem.merchandiseDuties[0].dutyRate =  item.merchandiseDuties[0].dutyRate || ""
            newLineItem.merchandiseDuties[0].duty =  item.merchandiseDuties[0].duty || ""
            newLineItem.merchandiseDuties[0].charges =  item.merchandiseDuties[0].charges || ""
            newLineItem.merchandiseDuties[0].IRTax =  item.merchandiseDuties[0].IRTax || ""
            newLineItem.merchandiseDuties[0].otherFee =  item.merchandiseDuties[0].otherFee || ""
            newLineItem.merchandiseDuties[0].mpf =  item.merchandiseDuties[0].mpf || {}
            newLineItem.merchandiseDuties[0].hmf =  item.merchandiseDuties[0].hmf || {}
            newLineItem.merchandiseDuties[0].specificRate =  item.merchandiseDuties[0].specificRate || ""
            newLineItem.merchandiseDuties[0].otherRate =  item.merchandiseDuties[0].otherRate || ""
            newLineItem.merchandiseDuties[0].adValoremDuty =  item.merchandiseDuties[0].adValoremDuty || ""
            newLineItem.merchandiseDuties[0].specificDuty =  item.merchandiseDuties[0].specificDuty || ""
            newLineItem.merchandiseDuties[0].otherDuty =  item.merchandiseDuties[0].otherDuty || ""
            newLineItem.merchandiseDuties[0].additionalDuties =  item.merchandiseDuties[0].additionalDuties || {}
            newLineItem.merchandiseDuties[0].adcvd =  item.merchandiseDuties[0].adcvd || {}
            // end new added
            newLineItem.merchandiseDuties[0].isCommodityDuty =  item.merchandiseDuties[0].isCommodityDuty
           
            newLineItem.merchandiseDuties[0].charges =  (parseFloat(item.merchandiseDuties[0].charges) || 0).toFixed(2)
             
            newLineItem.commodityMerchandiseDutyId =  item.merchandiseDuties[0].merchandiseDutyId
           
            newLineItem.manufacturerId =   item.merchandiseDuties[0].manufacturerId
          
            store.dispatch(addMerchandiseLineItem(invoiceItemIndex ,newLineItem, insertIndex));
          })
      }else if(lineType === 'ArticleSetSubComponent' || lineType === 'NormalLineItem' ){
        let newLineItem = merchandiseLineItem()
        newLineItem.merchandiseId = response.data.eventMessage.merchandiseId
       newLineItem.grossWeight.weight=  get(response, 'data.eventMessage.grossWeight.weight') || ""
       newLineItem.grossWeight.weightUnits=  get(response, 'data.eventMessage.grossWeight.weightUnits') || "None"
        newLineItem.productClaimCode=  get(response, 'data.eventMessage.productClaimCode') || ""
        newLineItem.partRefreshFlag=  get(response, 'data.eventMessage.partRefreshFlag') || ""
        newLineItem.categoryCode=  get(response, 'data.eventMessage.categoryCode') || ""
        newLineItem.importerAdditionalDeclarationDetails =  get(response, 'data.eventMessage.importerAdditionalDeclarationDetails') || null
        
        newLineItem.merchandiseDuties[0].merchandiseDutyId =response.data.eventMessage?.merchandiseDuties && response.data.eventMessage?.merchandiseDuties[0]?.merchandiseDutyId||''
          
        newLineItem.merchandiseDuties[0].isCommodityDuty =  response.data.eventMessage?.merchandiseDuties[0]?.isCommodityDuty||''
        newLineItem.merchandiseDuties[0].manifestQuantity =  get(response, 'data.eventMessage.merchandiseDuties[0].manifestQuantity') || {}
        newLineItem.merchandiseDuties[0].additionalQuantity =  get(response, 'data.eventMessage.merchandiseDuties[0].additionalQuantity') || {}
        newLineItem.merchandiseDuties[0].unitPrice =  (parseFloat(get(response, 'data.eventMessage.merchandiseDuties[0].unitPrice') || 0)).toFixed(2)
        newLineItem.merchandiseDuties[0].enteredValue =  (parseFloat(get(response, 'data.eventMessage.merchandiseDuties[0].enteredValue')||0)) || ""
        newLineItem.merchandiseDuties[0].charges =   (parseFloat(response.data.eventMessage.merchandiseDuties[0].charges) || 0).toFixed(2)
        newLineItem.merchandiseDuties[0].enteredValue =   (parseFloat(get(response, 'data.eventMessage.merchandiseDuties[0].enteredValue') || 0)).toFixed(2)
        newLineItem.merchandiseDuties[0].dutyRate =   (parseFloat(get(response, 'data.eventMessage.merchandiseDuties[0].dutyRate') || 0)).toFixed(2)
        newLineItem.merchandiseDuties[0].duty =   (parseFloat(get(response, 'data.eventMessage.merchandiseDuties[0].duty') || 0)).toFixed(2)
        newLineItem.merchandiseDuties[0].IRTax =   (parseFloat(get(response, 'data.eventMessage.merchandiseDuties[0].IRTax') || 0)).toFixed(2)
        newLineItem.merchandiseDuties[0].otherFee =   (parseFloat(get(response, 'data.eventMessage.merchandiseDuties[0].otherFee') || 0)).toFixed(2)
        newLineItem.merchandiseDuties[0].mpf =  get(response, 'data.eventMessage.merchandiseDuties[0].mpf')||{}
        newLineItem.merchandiseDuties[0].hmf =  get(response, 'data.eventMessage.merchandiseDuties[0].hmf')||{}
        newLineItem.merchandiseDuties[0].specificRate =   (parseFloat(get(response, 'data.eventMessage.merchandiseDuties[0].specificRate') || 0)).toFixed(2)
        newLineItem.merchandiseDuties[0].otherRate =   (parseFloat(get(response, 'data.eventMessage.merchandiseDuties[0].otherRate') || 0)).toFixed(2)
        newLineItem.merchandiseDuties[0].adValoremDuty =   (parseFloat(get(response, 'data.eventMessage.merchandiseDuties[0].adValoremDuty') || 0)).toFixed(2)
        newLineItem.merchandiseDuties[0].specificDuty =   (parseFloat(get(response, 'data.eventMessage.merchandiseDuties[0].specificDuty') || 0)).toFixed(2)
        newLineItem.merchandiseDuties[0].otherDuty =   (parseFloat(get(response, 'data.eventMessage.merchandiseDuties[0].otherDuty') || 0)).toFixed(2)
        newLineItem.merchandiseDuties[0].adcvd =  get(response, 'data.eventMessage.merchandiseDuties[0].adcvd')||{}
        
        newLineItem.commodityMerchandiseDutyId =   response.data.eventMessage.merchandiseDuties[0].merchandiseDutyId||''
        
        newLineItem.manufacturerId =  response.data.eventMessage.merchandiseDuties[0].manufacturerId||''
         
          newLineItem.seqNo =  response.data.eventMessage.seqNo || ''
          newLineItem.pgaFlags =  get(response, 'data.eventMessage.pgaFlags') || {}
          if(response.data.eventMessage.articleHeader === 'V'){
            newLineItem.articleHeader =  response.data.eventMessage.articleHeader || ''
            newLineItem.articleSetId =  response.data.eventMessage.articleSetId || ''
            store.dispatch(updateArticleSubComponent(response.data.eventMessage.articleSetId, response.data.eventMessage.merchandiseId , invoiceItemIndex))
          }
        store.dispatch(addMerchandiseLineItem(invoiceItemIndex , newLineItem, insertIndex))
      }
      updateStatus(merchandiseId)
    })
}

export const createMerchandiseDutyItem = (invoiceItemIndex,invoiceId, merchandiseId, merchIndex, dutyAddStatus, hts = '', pscShipId, data) => {
  if(data?.htsNo & hts){
    let dedupeString = 'AddedMerchandise'+merchandiseId+"XX"+merchIndex+"XX"+dutyAddStatus+"XX"+hts+JSON.stringify(data);
    if((window[dedupeString]||0)+30000 > Date.now() )return;
    window[dedupeString] = Date.now();

  }
  let dataSent = createEvent({
    descriptionOfMerchandise: {
      entrySummaryInvoices:[{
        invoiceId,
        merchandiseLineItems: [
          {  
            shipmentId: window.shipmentId,
            merchandiseId,
            merchandiseDuties: [
              {
                unitPrice: 0,
                htsus: (data?.htsNo || "").replaceAll(".","").trim(),
                htsDescription: data?.displayDescription || ""
              }
            ]
          }
        ]

      }]
     
    },
    shipmentId: (pscShipId || window.shipmentId)
  })
  console.log('CREATE MerchandiseDutyItem', dataSent)
  return HttpClient.post(dataSent).then(response => {
    if(!response?.data?.eventMessage){
      alert(`CREATION OF SUBDUTY HAS FAILED! ${hts}! ${JSON.stringify(response)}`);
      console.log('Response', response)
      return;

    }
    dutyAddStatus && dutyAddStatus()
    console.log('Response', response)
    let newDutyItem = merchandiseDuty(hts)
    newDutyItem.isCommodityDuty =
      response.data.eventMessage.isCommodityDuty || 2
    let commodityDuty = newDutyItem.isCommodityDuty;
    newDutyItem.merchandiseDutyId = response.data.eventMessage.merchandiseDutyId
    if(data){
      newDutyItem.htsus = (data.htsNo || "").replaceAll(".","").trim();
      newDutyItem.whenDutyItemCreated = Date.now();
      newDutyItem.htsDescription = data.displayDescription || "";
      if(data.applicableDuty){ 
        newDutyItem.dutyRate = data.applicableDuty
      }
    }
    store.dispatch(addDutyItem(invoiceItemIndex, merchIndex, newDutyItem))
    // This saves the incorrect duty rate and sets the ui duty to 0 :(
    // saveDutyRate(invoiceId, merchandiseId, pscShipId, data, newDutyItem.merchandiseDutyId, commodityDuty)
  })
}

// const saveDutyRate = (invoiceId, merchandiseId, pscShipId, data, merchandiseDutyId, commodityDuty) => {
//   let eventMsg = {
//     descriptionOfMerchandise: {
//       entrySummaryInvoices:[{
//         invoiceId,
//         merchandiseLineItems: [
//           {  
//             shipmentId: window.shipmentId,
//             merchandiseId,
//             merchandiseDuties: [
//               {
//                 "merchandiseDutyId": merchandiseDutyId,
//                 "dutyRate": data?.applicableDuty || "0.00",
//                 "isCommodityDuty": commodityDuty
//               }
//             ]
//           }
//         ]

//       }]
     
//     },
//     shipmentId: (pscShipId || window.shipmentId)
//   }
//   saveMerchandiseObject(eventMsg.descriptionOfMerchandise, window.shipmentId)
// }

export const createContainer = index => {
  let dataSent = createEvent({
    bolInfo: {
      container: [
        {
          number: '',
          size: ''
        }
      ]
    },
    shipmentId: window.shipmentId
  })
  console.log('CREATE Container', dataSent)
  return HttpClient.post(dataSent).then(response => {
    console.log('Response', response)
    let newContainer = container()
    newContainer.containerId =
      response.data.eventMessage.bolInfo.container[0].containerId
    newContainer.size =
      response.data.eventMessage.bolInfo.container[0].size
    store.dispatch(addContainer(newContainer))
  })
}

export const createManufacturer = () => {
  let dataSent = createEvent({
    importer: {
      headerParties: [
        {
          headerPartyType: "MANUFACTURER",
        }
      ]
    },
    shipmentId: window.shipmentId
  })
  console.log('CREATE Manufacturer', dataSent)
  let newManufacturer = manufacturer()
  store.dispatch(addManufacturer(newManufacturer))
  // return HttpClient.post(dataSent).then(response => {
  //   newManufacturer.headerId =
  //     response.data.eventMessage.importer.headerParties[0].headerId
  //   console.log('Response', response)
  // })
}

export const createInvoice = (totalInvoiceItem , updateStatus, shipmentId) => {
  if(!shipmentId){alert('missing shipmentId! Error!');return;}
  let eventMsg = {
    descriptionOfMerchandise: {
      entrySummaryInvoices: [
        {
          shipmentId: shipmentId 
        }
      ]
    },
    shipmentId: shipmentId
  }
  let dataSent = createEvent(eventMsg)
  return HttpClient.post(dataSent)
    .then(response => {
    
      if(response.data.eventMessage.code && response.data.eventMessage.code!=200){
        console.log('ERROR::  create invoice', response.data.eventMessage);
        return;
      }
      if(response.data.eventMessage){
            let newInvoiceItem = invoiceItemData()
            newInvoiceItem.invoiceId = response.data.eventMessage.invoiceId||''
        newInvoiceItem.invoiceNumber = response.data.eventMessage.invoiceNumber||''
        newInvoiceItem.invoiceDate = response.data.eventMessage.invoiceDate || '-999'
        newInvoiceItem.poNumber  = response.data.eventMessage.poNumber ||''
        newInvoiceItem.frieghtCharges= response.data.eventMessage.frieghtCharges||''
        newInvoiceItem.frieghtInsurance= response.data.eventMessage.frieghtInsurance||''
        newInvoiceItem.showLoader= false
        newInvoiceItem.expandInvoiceItem  = totalInvoiceItem < 5 ? true : false
        // newInvoiceItem.showFrightData= checkFrieghtShouldBeDispalyed(response.data.eventMessage.frieghtCharges,response.data.eventMessage.frieghtInsurance , response.data.eventMessage.otherDeductions)
        newInvoiceItem.otherDeductions= response.data.eventMessage.otherDeductions||''
        newInvoiceItem.totalEnteredValue= response.data.eventMessage.totalEnteredValue||''
        newInvoiceItem.invoiceAmount  =  (response.data.eventMessage.invoiceAmount  ==="0.0" || response.data.eventMessage.invoiceAmount  ==="-999.0") ?  "" : response.data.eventMessage.invoiceAmount ||'' 
        newInvoiceItem.merchandiseLineItems = response.data.eventMessage.merchandiseLineItems||[]
        store.dispatch(createInvoiceLineItem(newInvoiceItem));
          }
          updateStatus()
      }
    )}

